import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { cacheGet } from '../util/cache';
import { associateGetService } from '../services/associate.service';
import { GetUser } from '../features/authentication/hooks/useToken';

const defaultClientUser = {
  associateId: undefined,
  firstName: undefined,
  lastName: undefined,
  legalFirstName: undefined,
  legalLastName: undefined,
  email: undefined,
  phone: undefined,
  birthDate: undefined,
  externalId: undefined,
  taxId: undefined,
  taxResaleNumber: undefined,
  backOfficeId: undefined,
  languageCode: undefined,
  termsIP: undefined,
  singUpDate: undefined,
  acceptedTerms: undefined,
  associateStatusId: undefined,
  phoneCode: undefined,
  userType: undefined,
  associateStatus: undefined,
  pillarsId: undefined,
  enrollerId: undefined,
  shippingAddress: undefined,
  billingAddress: undefined,
  webAlias: undefined,
  userTypeId: undefined,
  tygaUserId: undefined,
  associateKYC: undefined,
};

// Create the context
const ClientUserContext = createContext(defaultClientUser);

// Provider component
export const ClientUserProvider = ({ children }) => {
  const [ready, setReady] = useState(false);
  const [loggedInUser] = useState(GetUser());
  const [customerId, setCustomerId] = useState(null);
  const [clientUser, setClientUser] = useState(null);
  const [userRole, setUserRole] = useState();

  const token = cacheGet('apiToken');

  // Update client account data
  const updateClientUser = (data) => {
    setClientUser((prevState) => ({ ...prevState, ...data }));
  };
  useEffect(() => {
    const getAssoc = async () => {
      const assocId = token?.associateId === 0 ? customerId : token?.associateId;
      try {
        if (assocId) {
          // /* eslint-disable no-debugger */
          // debugger;
          // /* eslint-enable no-debugger */
          const associate = await associateGetService(assocId);
          setClientUser(associate);
          setReady(true);
        }
      } catch (error) {
        console.error('Error fetching associate data:', error);
        setReady(true);
      }
    };
    if (token?.jwtToken && !clientUser) {
      getAssoc();
    }
  }, [token, customerId, clientUser]);

  useEffect(() => {
    if (!userRole && token?.userRole) {
      setUserRole(token?.userRole);
    }
  }, [userRole, token?.userRole]);

  useEffect(() => {
    if (!ready && clientUser) {
      setReady(true);
    }
  }, [ready, clientUser]);

  return (
    <ClientUserContext.Provider
      value={{
        clientUser,
        ready,
        userRole,
        loggedInUser,
        updateClientUser,
        setCustomerId,
        setUserRole,
        setClientUser,
      }}
    >
      {children}
    </ClientUserContext.Provider>
  );
};

ClientUserProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useClientUser = () => {
  const context = useContext(ClientUserContext);
  if (!context) {
    throw new Error('useClientUser must be used within a ClientUserProvider');
  }
  return context;
};
